<template>
  <div class="bg_white boxs2 pl16 pr16 pt15 pb16">
    <h2 class="page_title ab c5a">口座変更</h2>
    <div class="radio_wrap">
      <div class="payment_item bdb">
        <input v-on:click="changeRadio(false)" :checked="!bankAccount.postOffice" id="other_yucho" class="payment_radio" type="radio" name="payment">
        <label for="other_yucho" class="payment_contents rb">ゆうちょ銀行以外の金融機関</label>
      </div>
      <div class="payment_item p18 bdb">
        <input v-on:click="changeRadio(true)" :checked="bankAccount.postOffice" id="yucho" class="payment_radio" type="radio" name="payment">
        <label for="yucho" class="payment_contents rb">ゆうちょ銀行</label>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['bankAccount'],
  methods: {
    changeRadio(status) {
      this.bankAccount.postOffice = status;
    }
  },
  watch: {
    'bankAccount.postOffice': function(val) {
      this.$emit('changeRadio', val);
    },
    // bankAccount: {
    //   deep: true,
    //   handler() {
    //     this.$emit('changeRadio', this.bankAccount.postOffice);
    //   }
    // }

  }
}
</script>

<style lang="css" scoped>
.radio_wrap {
  margin-top: 40px;
}
.payment_item {
  margin-top: 30px;
  padding-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/Radio.vue